<script lang="ts">
	import { push } from "svelte-spa-router";

	function returnHome() {
		push("/");
	}
</script>

<div class="wrapper">
	Generation has failed<br />
	<div class="error">You have exceeded the allowed number of presentations per month</div>
	<button onclick={returnHome}>return to homepage</button>
</div>

<style>
	.wrapper {
		height: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		gap: 0.5rem;
	}
	.error {
		color: red;
		font-weight: bold;
	}
</style>
